//* 화환 주문(ShopOrder) 결제·배송 상태의 운영 표기 단일 출처.
//* 화면마다 Record를 따로 두다 보니 같은 상태를 다르게 부르는 일이 생겨서(예: Canceled를
//* '취소'/'취소완료'로 제각각) 여기로 모았다. 새 화면은 이 모듈만 쓴다.
//*
//* 맥락상 다르게 불러야 하는 화면은 overrides로 그 항목만 덮는다 —
//* 예) 전화응대 검색은 NotPaid가 "주문서 만들다 만 건"이라 '작성중(미결제)'로 보여야 하고,
//*     삭제주문 검색은 "복원이 필요한 상태"를 강조해야 한다.

import { DeliveryState, PaymentState } from '@shared/types';

export interface StatusBadge {
  label: string;
  /** csMemo roleBadge와 같은 모양 — 뱃지 배경·글자색 tailwind 클래스 */
  className: string;
}

type LabelOverrides = Partial<Record<string, string>>;

export const PAYMENT_STATUS_LABEL: Record<PaymentState, string> = {
  [PaymentState.NOT_PAID]: '미결제',
  [PaymentState.WAITING]: '입금대기',
  [PaymentState.PAID]: '결제완료',
  [PaymentState.CONFIRMED]: '구매확정',
  [PaymentState.CANCEL_REQUESTED]: '취소요청',
  [PaymentState.CANCELED]: '결제취소',
};

export const DELIVERY_STATUS_LABEL: Record<DeliveryState, string> = {
  [DeliveryState.BEFORE_PREPARING]: '준비전',
  [DeliveryState.PREPARING]: '준비중',
  [DeliveryState.DELIVERYING]: '배송중',
  [DeliveryState.DELIVERED]: '배송완료',
};

const PAYMENT_STATUS_CLASS: Record<PaymentState, string> = {
  [PaymentState.NOT_PAID]: 'bg-gray-100 text-gray-600',
  [PaymentState.WAITING]: 'bg-amber-100 text-amber-700',
  [PaymentState.PAID]: 'bg-green-100 text-green-700',
  [PaymentState.CONFIRMED]: 'bg-emerald-100 text-emerald-800',
  [PaymentState.CANCEL_REQUESTED]: 'bg-orange-100 text-orange-700',
  [PaymentState.CANCELED]: 'bg-red-100 text-red-700',
};

const DELIVERY_STATUS_CLASS: Record<DeliveryState, string> = {
  [DeliveryState.BEFORE_PREPARING]: 'bg-gray-100 text-gray-600',
  [DeliveryState.PREPARING]: 'bg-sky-100 text-sky-700',
  [DeliveryState.DELIVERYING]: 'bg-blue-100 text-blue-700',
  [DeliveryState.DELIVERED]: 'bg-green-100 text-green-700',
};

//* 모르는 값이 오면 원문을 그대로 돌려준다 — 서버가 상태를 늘렸을 때 화면이 빈칸이 되는 것보다 낫다
export const paymentStatusLabel = (status?: string, overrides?: LabelOverrides): string =>
  overrides?.[status ?? ''] ??
  PAYMENT_STATUS_LABEL[status as PaymentState] ??
  status ??
  '-';

export const deliveryStatusLabel = (
  status?: string,
  overrides?: LabelOverrides,
): string =>
  overrides?.[status ?? ''] ??
  DELIVERY_STATUS_LABEL[status as DeliveryState] ??
  status ??
  '-';

export const paymentStatusBadge = (
  status?: string,
  overrides?: LabelOverrides,
): StatusBadge => ({
  label: paymentStatusLabel(status, overrides),
  className: PAYMENT_STATUS_CLASS[status as PaymentState] ?? 'bg-gray-100 text-gray-600',
});

export const deliveryStatusBadge = (
  status?: string,
  overrides?: LabelOverrides,
): StatusBadge => ({
  label: deliveryStatusLabel(status, overrides),
  className:
    DELIVERY_STATUS_CLASS[status as DeliveryState] ?? 'bg-gray-100 text-gray-600',
});
